import type { RouteRecordRaw } from 'vue-router';

export const MONTHLY_SALES_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/monthly',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/monthly/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/monthly/views/List.vue'),
        name: 'Monthly Sales List',
        meta: {
          title: '월별 매출조회',
        },
      },
    ],
  },
];
